// extracted by mini-css-extract-plugin
module.exports = {"quantityGradeNotAcceptable":"quantityGradeNotAcceptable--dc178","quantityGradeOk":"quantityGradeOk--985e0","quantityGradePerfect":"quantityGradePerfect--bf424"};